import { createAction } from 'redux-actions';

export const SNACKBAR_OPEN = createAction('SNACKBAR_OPEN');
export const SNACKBAR_CLEAR = createAction('SNACKBAR_CLEAR');

export const showSnackBar = (message, severity) => {
  return (dispatch, getState) => {       
    dispatch(SNACKBAR_OPEN({message, severity}));
  };
};

export const clearSnackbar = () => {
  return (dispatch, getState) => {        
    dispatch(SNACKBAR_CLEAR());
  };
};
